const translations = {
    create: 'create',
    nextDrawThePerimeter: 'next: draw the perimeter'
};

export default translations;
